import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin-bottom: 15px;
  overflow-wrap: anywhere;

  .sku {
    font-size: 10px;
    letter-spacing: 0.06em;
    line-height: 12px;
    margin-bottom: 15px;

    .npn {
      margin-left: 25px;
    }
  }
`

export const DelayedBilling = styled.div``

export const DelayedBillingMessage = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.brandBlue.dark100};
    font-size: 10px;
  `,
)

export const DelayedBillingPrice = styled.span(
  ({ theme }) => css`
    ${theme.typography.h3};
    color: ${theme.colors.brandBlue.dark100};
    font-size: 18px;
  `,
)

export const Tagline = styled.h4`
  text-transform: uppercase;
  font-weight: 400;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 14px;
  margin-bottom: 1rem;
  letter-spacing: 0.06em;
  line-height: 16px;
`

export const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

export const Price = styled.span(
  ({ theme }) => css`
    ${theme.typography.h3};
    color: ${theme.colors.brandBlue.dark100};
    font-size: 21px;
  `,
)

export const Prices = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RetailPrice = styled.span(
  ({ theme }) => css`
    ${theme.typography.h3};
    color: ${theme.colors.grayscale.gray40};
    font-weight: 600;
    font-size: inherit;
  `,
)

export const Retail = styled.span<{ $isOnlyPrice?: boolean }>`
  ${({ theme }) => theme.typography.h3};
  margin-left: ${({ $isOnlyPrice }) => ($isOnlyPrice ? 0 : 10)}px;
  font-size: ${({ $isOnlyPrice }) => ($isOnlyPrice ? 21 : 16)}px;
  font-weight: unset;
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const HeaderImage = styled.img`
  display: block;
  max-width: 240px;
  margin-bottom: 1rem;
`
